import { render, staticRenderFns } from "./editgroup-info.vue?vue&type=template&id=a1f64d2a&scoped=true"
import script from "./editgroup-info.vue?vue&type=script&lang=js"
export * from "./editgroup-info.vue?vue&type=script&lang=js"
import style0 from "./editgroup-info.vue?vue&type=style&index=0&id=a1f64d2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f64d2a",
  null
  
)

export default component.exports